module.exports = __webpack_public_path__ + "img/loader.85135c1c.gif";